import * as React from 'react';
import styled from 'styled-components';

type CarouselMapProps = {
  address: string;
  interactive?: boolean;
  coordinates?: {
    lat: number;
    lng: number;
  };
};

const CarouselMap: React.FunctionComponent<CarouselMapProps> = ({
  address,
  interactive = false,
  coordinates,
}) => {
  const baseUrl = `https://www.google.com/maps/embed/v1/place?key=${window.GOOGLE_MAPS_EMBED_KEY}`;
  const mapsEmbedUrl =
    coordinates?.lat && coordinates?.lng
      ? `${baseUrl}&q=${coordinates.lat},${coordinates.lng}`
      : `${baseUrl}&q=${address}`;

  return (
    <div
      className="listing-view-asset"
      style={{ height: '100%', width: '100%', position: 'relative' }}
    >
      {typeof (window as any).google !== 'undefined' && (
        <iframe
          width="100%"
          height="100%"
          style={{ border: 0 }}
          src={mapsEmbedUrl}
        ></iframe>
      )}

      {!interactive && google && (
        // HACK: Overlay divs to capture onClick events while leaving a corner for zoom buttons.
        <>
          <ClickCaptureDiv />
          <ClickCaptureDiv vertical />
        </>
      )}
    </div>
  );
};

export default CarouselMap;

const ClickCaptureDiv = styled.div<{
  vertical?: boolean;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: ${props => (props.vertical ? 'calc(100% - 50px)' : '100%')};
  height: ${props => (props.vertical ? '100%' : 'calc(100% - 105px)')};
`;
